import { useState, useCallback, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import styles from "./style.module.scss";
import classNames from "classnames";
import { toastMessage } from "../toast";
import { Icons } from "assets";

interface CustomFileUploadProps {
  label?: string;
  required?: boolean;
  defaultImage?: string | null;
  onFileChange: (file: File | null | string) => void;
}

const CustomFileUpload = ({
  label,
  required = false,
  // @ts-ignore
  defaultImage = null,
  onFileChange,
}: CustomFileUploadProps) => {
  const [uploadedFile, setUploadedFile] = useState<string | null>(defaultImage);

  useEffect(() => {
    if (defaultImage) {
      setUploadedFile(defaultImage);
      // onFileChange(defaultImage);
    }
  }, [defaultImage]);

  const handleFileUpload = (file: File) => {
    const reader = new FileReader();
    reader.onload = () => {
      setUploadedFile(reader.result as string);
      onFileChange(file);
    };
    reader.onerror = () => {
      console.error("Failed to read file");
      alert("Failed to upload file");
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveFile = () => {
    setUploadedFile(null);
    onFileChange(null);
    toastMessage("success", "File has been removed");
  };

  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) {
      handleFileUpload(acceptedFiles[0]);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
  });

  return (
    <div className={classNames(styles.fileUploadWrapper)}>
      <div className="flex flex-col items-start gap-2 w-full h-full">
        <label className="label">
          {label}
          {required && <span className="asterik">*</span>}
        </label>
        {uploadedFile ? (
          <div className={classNames(styles.filePreviewContainer, "relative")}>
            <img
              src={uploadedFile}
              alt="Uploaded file preview"
              className="w-32"
            />
            <button
              type="button"
              className={classNames(styles.removeButton)}
              onClick={handleRemoveFile}
            >
              <Icons.Cross />
            </button>
          </div>
        ) : (
          <div className={classNames(styles.uploadContainer)}>
            <div
              {...getRootProps({
                className: ` cursor-pointer w-full h-full flex items-center justify-center ${
                  isDragActive ? "border-blue-500" : "border-gray-300"
                }`,
              })}
            >
              <input {...getInputProps()} />
              <p>
                {isDragActive
                  ? "Drop the files here..."
                  : "Upload Image or Drag & Drop"}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomFileUpload;
